export default __webpack_public_path__ + "a4e4744ec6c117b0b7f0afc2741846a2.svg";